import { CONTRACT_SIDE_MENU, TOGGLE_SIDE_MENU, GeneralActionTypes, SET_COMPANIES, SELECT_COMPANY } from 'types/store';

export function contractSideMenu(): GeneralActionTypes {
  return { type: CONTRACT_SIDE_MENU };
}

export function toggleSideMenu(): GeneralActionTypes {
  return { type: TOGGLE_SIDE_MENU };
}

export function setCompanies(companies: { id: string; legal_name: string }[]): GeneralActionTypes {
  return { type: SET_COMPANIES, companies };
}

export function selectCompany(selectedCompanyId: string): GeneralActionTypes {
  return { type: SELECT_COMPANY, selectedCompanyId };
}
